import { ICBBranch } from "../store/cbBranchesReducer";

export const SET_CB_BRANCHES = "SET_CB_BRANCHES";
export const SET_CB_COUNTRY = "SET_CB_COUNTRY";
export const SET_CB_DIRECTION = "SET_CB_DIRECTION";
export const TOGGLE_CB_BRANCHES = "TOGGLE_CB_BRANCHES";

export const SetCBBranches = (branches: ICBBranch[]) => {
    return { type: SET_CB_BRANCHES, branches };
};
export const SetCBCountry = (country: string) => {
    return { type: SET_CB_COUNTRY, country };
};
export const SetCBDirection = (direction: string) => {
    return { type: SET_CB_DIRECTION, direction };
};
export const ToggleCBBranches = (branch: ICBBranch) => {
    return { type: TOGGLE_CB_BRANCHES, branch };
};
